/**
 * Default configuration values
 */
export const DEFAULT_CONFIG = {
    AJAX_TIMEOUT: 30000, // 30 seconds
    SCROLL_OFFSET: 100, // Offset for scrolling to comments
    ANIMATION_DURATION: 300, // Duration for fade effects
    HIGHLIGHT_DURATION: 3000 // 3 seconds
};
